"use strict";

// module Partial.Unsafe

exports.unsafePartial = function (f) {
  return f();
};



//////////////////
// WEBPACK FOOTER
// ./output/Partial.Unsafe/foreign.js
// module id = 306
// module chunks = 0